export default __webpack_public_path__ + "static/media/onboardingImage.2d1a4dd7.png";